import { render, staticRenderFns } from "./WelcomePage.vue?vue&type=template&id=d1f629e6&scoped=true&"
import script from "./WelcomePage.vue?vue&type=script&lang=ts&"
export * from "./WelcomePage.vue?vue&type=script&lang=ts&"
import style0 from "./WelcomePage.vue?vue&type=style&index=0&id=d1f629e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f629e6",
  null
  
)

export default component.exports